module.exports = __webpack_public_path__ + "static/media/flip-jump.eb983f9d.jpg";